import { useEffect } from "react";

export default function useEscapeKey(action: (e: KeyboardEvent) => void) {
  useEffect(() => {
    const escape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        action(e);
      }
    };
    document.addEventListener("keydown", escape);

    return () => {
      document.removeEventListener("keydown", escape);
    };
  }, []);
}
